import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useBooking } from '../contexts/BookingContext';
import { checkAndFireReminders, requestNotificationPermission } from '../utils/reminders';

/**
 * Runs the reminder check whenever client bookings change.
 * Fires in-app + browser notifications for due reminders.
 */
export const useReminders = () => {
  const { user } = useAuth();
  const { clientBookings } = useBooking();

  useEffect(() => {
    if (!user?.uid) return;
    if (!Array.isArray(clientBookings) || clientBookings.length === 0) return;

    const run = async () => {
      if ('Notification' in window && Notification.permission === 'default') {
        try {
          await requestNotificationPermission();
        } catch {
          // Silent
        }
      }

      try {
        await checkAndFireReminders(clientBookings, user.uid);
      } catch (err) {
        console.error('Reminder check failed:', err);
      }
    };

    run();
  }, [user?.uid, clientBookings]);
};

export default useReminders;